<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">快捷导航</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12" class="firstCls">
          <el-row :gutter="5">
            <el-col :span="12">
              <span>商家数统计：</span>
            </el-col>
            <el-col :span="12">
              <span>{{quicklyData.allBusinessNums}}</span>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <span>增值服务余额：</span>
            </el-col>
            <el-col :span="12">
              <span>{{quicklyData.attachServiceBalancsMoney}}</span>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <span style="color: blue;">系统总账余额：</span>
            </el-col>
            <el-col :span="12">
              <span style="color: red;">{{quicklyData.systemAccountBalanceMoney}}</span>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <span>未结算本金：</span>
            </el-col>
            <el-col :span="12">
              <span>{{quicklyData.unBalanceMoney}}</span>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <span>未结算佣金：</span>
            </el-col>
            <el-col :span="12">
              <span>{{quicklyData.unCommissionMoney}}</span>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <span>时间：</span>
            </el-col>
            <el-col :span="12">
              <span>{{quicklyData.dateTime}}</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12" class="firstCls">
          <el-row :gutter="5">
            <el-col :span="12">
              <span>会员数统计：</span>
            </el-col>
            <el-col :span="12">
              <span>{{quicklyData.allCustomerNums}}</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <el-divider></el-divider>
    <el-card>
      <el-row :gutter="2" class="secondCls">
        <el-col :span="6">
          <el-badge :value="badgeNumbers.bInvestReviewNum" class="item">
            <el-button plain @click="businessInvistReview">商家充值待审核</el-button>
          </el-badge>
        </el-col>
        <el-col :span="6">
          <el-badge :value="badgeNumbers.bGetMoneyReviewNum" class="item">
            <el-button plain @click="businessCashOutReview">商家提现待审核</el-button>
          </el-badge>
        </el-col>
        <el-col :span="6">
          <el-badge :value="badgeNumbers.bCustomeReviewNum" class="item">
            <el-button plain @click="salemanCashOutReview">业务员提现待审核</el-button>
          </el-badge>
        </el-col>
        <el-col :span="6">
          <el-badge :value="badgeNumbers.customCashOutReviewNum" class="item">
            <el-button plain @click="cusotmerCashOutReview">试客提现待审核</el-button>
          </el-badge>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {
  queryAdminQuicklyData,
  queryBusinessWaitReturnMoneyNumbers,
} from "@/api/b2cbusiness/b2c_allquicklydata";
import {queryNumbersWithStatus} from "@/api/b2cbusiness/b2c_investmoney";
import {queryCashOutNumbersWithStatus} from "@/api/b2cbusiness/b2c_admin";

export default {
name: "FinanceFirstPage",
  data(){
    return {
      quicklyData:{
      },
      badgeNumbers:{
        bInvestReviewNum: "0",
        bGetMoneyReviewNum: "0",
        taskReviewNum: "0",
        complainReviewNum: "0",
        shopsReviewNum: "0",
        bCustomeReviewNum: "0",
        stationLetterNum: "0",
        rejectOrderNum: "",
        customIdCardReivewNum: "0",
        waitBusinessReturnMoneyNum: "",
        customAccountReviewNum: "0",
        customCashOutReviewNum: "0"
      }
    }
  },
  mounted() {
    queryAdminQuicklyData().then(res=>{
      if (res.success){
        this.quicklyData = res.data;
      }
    });

    queryNumbersWithStatus({statusStr:"未审核"}).then(res=>{
      if (res.success){
        this.badgeNumbers.bInvestReviewNum = res.data;
      }
    });

    queryCashOutNumbersWithStatus({roleId:"1409884924325670914", statusStr:"未审核"}).then(res=>{
      if (res.success){
        this.badgeNumbers.bGetMoneyReviewNum = res.data;
      }
    });

    queryCashOutNumbersWithStatus({roleId:"1435410074957545474", statusStr:"未审核"}).then(res=>{
      if (res.success){
        this.badgeNumbers.bCustomeReviewNum = res.data;
      }
    });

    queryCashOutNumbersWithStatus({roleId:"1435409842807013377", statusStr:"未审核"}).then(res=>{
      if (res.success){
        this.badgeNumbers.customCashOutReviewNum = res.data;
      }
    });

    queryBusinessWaitReturnMoneyNumbers().then(res=>{
      if (res.success){
        this.badgeNumbers.waitBusinessReturnMoneyNum = res.data;
      }
    });
  },
  methods:{
    businessInvistReview(){
      this.$router.push({path:'/home/accountdetlist', query:{userType:"商家", status:"未审核"}})
    },
    businessCashOutReview(){
      this.$router.push({path:'/home/accountoutchlist', query:{userType:"商家", status:"未审核"}})
    },
    salemanCashOutReview(){
      this.$router.push({path:'/home/accountoutchlist', query:{userType:"业务员", status:"未审核"}})
    },
    cusotmerCashOutReview(){
      this.$router.push({path:'/home/accountoutchlist', query:{userType:"试客", status:"未审核"}})
    },
  }
}
</script>

<style lang="scss" scoped>
.firstCls{
.el-row {
  margin: 15px;
.el-col{
  text-align: left;
span{
  color: #409EFF;
}
}
.el-col:first-child{
  text-align: right;
span{
  color: #303133;
}
}
}
}

.secondCls{
.el-col{
  margin: 10px;
}
}
</style>
